import { createStore, createHook } from '@atlassian/react-sweet-state';
import * as actions from './actions';
import { initialState } from './model';
import type { State } from './model/types.tsx';
import type { Actions } from './types';

export const Store = createStore<State, Actions>({
	name: 'jsw-up-flow-touchpoint',
	initialState,
	actions,
});

export const useActiveUpFlowTouchpointId = createHook(Store, {
	selector: (state: State) => state.activeUpFlowTouchpointId,
});
